import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneHref',
  standalone: true,
})
export class PhoneHrefPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (!value) return '';

    const digits = value.replace(/\D/g, '');

    if (!digits) return '';

    const normalized =
      digits.length === 11 && digits.startsWith('1') ? digits : `1${digits}`;

    return `tel:+${normalized}`;
  }
}
